import React from 'react'
import { useAppSelector } from 'app/hooks'
import {
    IconButton,
} from 'components'
import {
    RootState,
    NestedDict,
} from 'app/types'
import * as fnc from 'helpers/fnc'

interface TableOptionsProps {
    onDownload,
}
export function TableOptions(props: TableOptionsProps) {
    const {
        onDownload
    } = props

    return <div className="admin-table-options">
        {onDownload && <IconButton icon="fas fa-download" onClick={onDownload}/>}
        {props.children}
    </div>
}
